import { Subscription } from 'rxjs';

import { computed, effect, inject, Injectable, signal, Signal } from "@angular/core";
import { SettingsService } from '../domains/settings/settings.service';

export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemeModeInterface {
    mode: ThemeMode;
}

@Injectable({
    providedIn: 'root'
})
export class ThemeService {

    readonly isDarkmode = signal(false);

    private readonly settingsService = inject(SettingsService);

    readonly themeMode: Signal<ThemeMode> = computed(() => {
        const userSavedTheme = this.settingsService.themeMode();
        return userSavedTheme ?? 'system';
    });


    private subscriptions: Subscription[] = [];

    constructor() {
        const darkModePreference = window.matchMedia("(prefers-color-scheme: dark)");
        darkModePreference.addEventListener("change", e => this.applyTheme(e.matches ? 'dark' : 'light'));

        effect(() => {
            this.applyTheme(this.settingsService.themeMode());
        })
    }

    private applyTheme(mode: ThemeMode) {
        const root = document.documentElement;

        switch (mode) {
            case 'light':
                root.classList.remove('dark');
                this.isDarkmode.set(false);
                break;
            case 'dark':
                root.classList.add('dark');
                this.isDarkmode.set(true);
                break;
            case 'system':
                const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
                root.classList.remove('dark');
                root.classList.add(systemDark ? 'dark' : 'light');
                this.isDarkmode.set(systemDark ? true : false);
                break;
        }
    }

    dailyThemeToggle() {
        const day = new Date().getDate();
        if (day % 2 === 0) {
            this.applyTheme('light');
        } else {
            this.applyTheme('dark');
        }
    }
}
